import { render, staticRenderFns } from "./TinyCard.vue?vue&type=template&id=0a78ce44&scoped=true"
import script from "./TinyCard.vue?vue&type=script&lang=js"
export * from "./TinyCard.vue?vue&type=script&lang=js"
import style0 from "./TinyCard.vue?vue&type=style&index=0&id=0a78ce44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a78ce44",
  null
  
)

export default component.exports